import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "form-item" }
const _hoisted_2 = /*#__PURE__*/_createVNode("label", null, "当前角色：", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "form-item" }, [
  /*#__PURE__*/_createVNode("label", null, "使用权限：")
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 确定 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_menu_list = _resolveComponent("menu-list")
  const _component_a_col = _resolveComponent("a-col")
  const _component_a_row = _resolveComponent("a-row")
  const _component_a_spin = _resolveComponent("a-spin")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.store.state.role.setMenuState,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.store.state.role.setMenuState = $event)),
    width: "800px",
    title: "设置菜单",
    class: "set-menu-dialog auto-scroll-dialog",
    afterClose: _ctx.afterClose,
    maskClosable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        key: "back",
        onClick: _ctx.afterClose
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        key: "submit",
        type: "primary",
        loading: _ctx.loading,
        onClick: _ctx.onSubmit
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_spin, { spinning: _ctx.loading }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            _hoisted_2,
            _createTextVNode(_toDisplayString((_ctx.detail && _ctx.detail.name) || '-'), 1)
          ]),
          _hoisted_3,
          _createVNode("div", null, [
            _createVNode(_component_a_row, { gutter: 20 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.menus, (item, index) => {
                  return (_openBlock(), _createBlock(_component_a_col, {
                    span: 8,
                    key: item.code
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_menu_list, { node: item }, null, 8, ["node"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["spinning"])
    ]),
    _: 1
  }, 8, ["visible", "afterClose"]))
}